// AddItems.js
import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import api from "../Axios/api";
import ItemForm from "./AddEditItemForm";
import Swal from 'sweetalert2';
import { Trash2 } from 'lucide-react';
import { SquarePen } from 'lucide-react';
import Loader from "../common/Loader";
const AddItems = () => {
    const [rowCount, setRowCount] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);// Add Ledger Modal
    const [isChargeModalOpen, setIschargeModalOpen] = useState(false);// Add Charge Modal
      const [isloading, setIsLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    const [factoryLocation, setFactoryLocation] = useState([]);
    const [brandArray, setBrandArray] = useState([]);
    const [categoryArray, setCategoryArray] = useState([]);

    const [editId, setEditId] = useState(null);
    const [inputs, setInputs] = useState({
        item_title: "",
        item_category: "",
        item_brand: "",
        unit: "",
        gst: "",
        factory: "",
        stock_min_level:""
    });

    const [append, setAppend] = useState({
        category: "",
        brand: "",
        factory: "",
    });

    const [itemsData, setItemsData] = useState([]);

    const [extraCharges, setExtraCharges] = useState([]);

    const [ledgers, setLedgers] = useState([]);
    const[ledgerInput,setLegderInput]= useState({
     ledgerName: "",
     factory: "",
    })
    const[chargeInput,setChargeInput]= useState({
     chargeName: "",
     chargeFactory: "",
    })
    const [ledgerRowCount, setLedgerRowCount] = useState(0);
    const [ledgerPagination, setLedgerPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    const columns = useMemo(
        () => [
            {
                accessorKey: "sn",
                header: "SN",
                size: 50,
                Cell: ({ row }) => row.index + 1,
            },
            { accessorKey: "item_title", header: "Title" },
            { accessorKey: "item_cat_name", header: "Category" },
            {
                accessorKey: "stock_qty",
                header: "Stock Qty",
                Cell: ({ row }) => {
                    const qty = row.original.stock_qty ?? 0;
                    const unit = row.original.item_unit ?? "";

                    return `${qty} ${unit}`.trim();
                },
            },
            {
                accessorKey: "stock_value",
                header: "Stock Value",
                Cell: ({ row }) => row.original.stock_value ?? 0,
            },
            { accessorKey: "item_branch_name", header: "Fac" },
            {
                accessorKey: "action",
                header: "Action",
                Cell: ({ row }) => (
                    <div className="flex space-x-2">
                        <button
                            className="text-blue-600 hover:underline"
                            onClick={() => handleEdit(row)}
                        >
                           <SquarePen className="text-green-500 cursor-pointer" />
                        </button>
                        <button
                            onClick={() => handleDelete(row)}
                        >
                           <Trash2 className="text-red-500 cursor-pointer" />
                        </button>
                    </div>
                ),
            },
        ],
        []
    );

    const extraChargesColumns = [
        { accessorKey: "charge_name", header: "Charge Name" },
        {
            accessorKey: "charge_fac_id",
            header: "Factory",
            Cell: ({ cell }) => {
                const factoryMapping = {
                    "666c0f5ebeca5ab2c65b2c85": "POLYBOND INSULATION",
                    "666c0f5ebeca5ab2c65b2c86": "POLYBOND PROJECTS",
                };
                return factoryMapping[cell.getValue()] || "POLYBOND ROCKFIBRE";
            },
        },
        {
            header: "Action",
            Cell: ({ row }) => (
              <button onClick={() => deleteCharge(row)}>
                <Trash2 className="text-red-500 cursor-pointer" />
              </button>
            ),
          }
    ];

    const ledgersColumns = [
        { accessorKey: "purchase_ledger_name", header: "Ledger Name" },
        {
            accessorKey: "factory_details",
            header: "Factory",
            Cell: ({ row }) => row.original.factory_details?.fectory_loca_name || "",
        },
        {
            header: "Action",
            Cell: ({ row }) => (
              <button onClick={() => delete_ledger(row)}>
                <Trash2 className="text-red-500 cursor-pointer" />
              </button>
            ),
          }
          
    ];

    // const getItems = async () => {
    //     try {
    //         const { pageIndex, pageSize } = pagination;
    //         const response = await api.get(
    //             `purchase-item/get-item/?limit=${pageSize}&page=${pageIndex + 1}`
    //         );
    //         setItemsData(response.data.items || []);
    //         setRowCount(response.data.totalResults)
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };
    const getItems = async () => {
        try {   
            setIsLoading(true);
            const { pageIndex, pageSize } = pagination;
            const response = await api.get('purchase-item/get-item/', {
                params: {
                    limit: pageSize,
                    page: pageIndex + 1,
                    search: searchText.trim(),
                },
            });
            setItemsData(response.data.items || []);
            // console.log(response.data.items);
            setRowCount(response.data.totalResults);
            setIsLoading(false);
        } catch (error) {
            console.log(error);
        }
    };
    

    const preparePayload = ({ factory, item_category, item_brand, item_title, unit, gst,stock_min_level }) => ({
        item_title,
        item_unit: unit,
        item_gst: gst,
        item_itemcat: item_category,
        item_brand,
        item_branch: factory,
        stock_min_level
    });

    const addItem = async (e) => {
        e.preventDefault();
        try {
            const payload = preparePayload(inputs);
            const response = await api.post(`/purchase-item/add-items`, payload);
            const newItem = response.data;
            newItem.item_branch_name = append.factory;
            newItem.item_brand_name = append.brand;
            newItem.item_cat_name = append.category;
            setItemsData((prevData) => [newItem, ...prevData]);
            resetHandler();
        } catch (error) {
            console.log(error);
        }
    };

    const editItem = async (e, id) => {
        e.preventDefault();
        const payload = preparePayload(inputs);
        try {
            const response = await api.put(`/purchase-item/update-items/${id}`, payload);
            resetHandler();
            getItems();
        } catch (error) {
            console.log(error);
        }
    };

    const handleEdit = (row) => {
        setEditId(row.original._id);
        setInputs({
            item_title: row.original.item_title,
            item_category: row.original.item_itemcat,
            item_brand: row.original.item_brand,
            unit: row.original.item_unit,
            gst: row.original.item_gst,
            factory: row.original.item_branch,
            stock_min_level:row.original.stock_min_level ?? ""
        });
    };

    const charger_Open_Modal = () => {
        setIschargeModalOpen(true);
      };
    const ledger_Open_Modal = () => {
        setIsModalOpen(true);
      };

      const closeModal = () => {

        setIsModalOpen(false);
        setLegderInput({
            ledgerName: "",
            factory: ""
          });
          setIschargeModalOpen(false); 
          setChargeInput({
            chargeName: "",
            chargeFactory: ""
          });
      };
 


    ///This is Add Ledger Api  
      const add_ledger = async ( ) => {
        const addLedgerData = {
            purchase_ledger_name: ledgerInput.ledgerName,
            purchase_ledger_factory: ledgerInput.factory,
          };
          if (!addLedgerData.purchase_ledger_name || !addLedgerData.purchase_ledger_factory) {
            Swal.fire({
              icon: 'warning',
              title: 'Missing Fields',
              text: 'Please fill in both Ledger Name and Factory.',
            });
            return;
          }
        try {
            const response = await api.post(`/purchase-ledger/add`,addLedgerData);
            getExtraChargesAndLedgers();
            closeModal();
            Swal.fire({
                icon: 'success',
                title: 'Ledger Added',
                text: 'The ledger has been added successfully.',
                timer: 2000,
                showConfirmButton: false,
              });
        } catch (error) {
            console.log(error);
        }
    };

    const delete_ledger = async (row) => {
        const id = row.original._id;
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to delete"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
          }).then(async (result) => {
            if (result.isConfirmed) {
        try {
            const response = await api.delete(`/purchase-ledger/delete/${id}`);
            getExtraChargesAndLedgers();
            Swal.fire({
                icon: 'success',
                title: 'Ledger Deleted',
                text: 'The ledger has been Deleted successfully.',
                timer: 2000,
                showConfirmButton: false,
              });
        }
         catch (error) {
            console.log(error);
        }
    }
});
    };

    /////This is Add Charge Api
    const addCharge = async () =>
    {
      const chargeData =   {
        charge_name : chargeInput.chargeName,
        charge_fac_id:chargeInput.chargeFactory
      };
      if (!chargeData.charge_name || !chargeData.charge_fac_id) {
        Swal.fire({
          icon: 'warning',
          title: 'Missing Fields',
          text: 'Please fill in both Charge Name and Factory.',
        });
        return;
      }
    try {
        const response = await api.post(`/extra-charges/add`,chargeData);
        getExtraChargesAndLedgers();
        closeModal();
        Swal.fire({
            icon: 'success',
            title: 'Charge Added',
            text: 'The Charge has been added successfully.',
            timer: 2000,
            showConfirmButton: false,
          });
    } catch (error) {
        console.log(error);
    }
    };
    const deleteCharge = async (row) =>
    { 
        const id = row.original._id;
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to delete"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
          }).then(async (result) => {
            if (result.isConfirmed) {
        try {
            const response = await api.delete(`/extra-charges/delete/${id}`);
            getExtraChargesAndLedgers();
            Swal.fire({
                icon: 'success',
                title: 'Charge Deleted',
                text: 'The Charge has been Deleted successfully.',
                timer: 2000,
                showConfirmButton: false,
              });
        }
         catch (error) {
            console.log(error);
        }
    }
});

    };


    const handleDelete = async (row) => {
        const id = row.original._id;
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to delete"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
          }).then(async (result) => {
            if (result.isConfirmed) {
        try {
            const response = await api.delete(`/purchase-item/delete-items/${id}`);
            getItems();
            Swal.fire({
                icon: 'success',
                title: 'Item Deleted',
                text: 'The Item has been Deleted successfully.',
                timer: 2000,
                showConfirmButton: false,
              });
        } catch (error) {
            console.log(error);
        }
    }
   });
    }
    const resetHandler = () => {
        setInputs({
            item_title: "",
            item_category: "",
            item_brand: "",
            unit: "",
            gst: "",
            factory: "",
            stock_min_level: "",
        });
        setEditId(null);
    };

    const fetchInitialData = async () => {
        try {
            const [factoriesResponse, brandsResponse, categoriesResponse] = await Promise.all([
                api.get(`/factory-location/get-factory-location`),
                api.get(`/brand/get`),
                api.get(`/purchase-item-category/get-name`),
            ]);
            setFactoryLocation(factoriesResponse.data);
            setBrandArray(brandsResponse.data);
            setCategoryArray(categoriesResponse.data);
        } catch (error) {
            console.error("Error fetching initial data:", error);
        }
    };

    const getExtraChargesAndLedgers = async () => {
        try {
            const [extraChargesResponse, ledgersResponse] = await Promise.all([
                api.get(`/extra-charges/get`),
                api.get(`/purchase-ledger/get?page=${ledgerPagination.pageIndex + 1}&limit=${ledgerPagination.pageSize}`),
            ]);

            setExtraCharges(extraChargesResponse.data.extraCharges);
            setLedgers(ledgersResponse.data.ledgers);
            setLedgerRowCount(ledgersResponse.data.totalCount);
        }
        catch (error) {
            console.error("Error fetching extra charges and ledgers:", error);
        }
    }

    useEffect(() => {
        getItems();
        fetchInitialData();
    }, [pagination , searchText]);

    useEffect(() => {
        getExtraChargesAndLedgers();
    }, [ledgerPagination]);

    return (
        <div className="flex flex-col relative">
            <div className="flex flex-col lg:flex-row gap-6 p-6 h-[680px]">
                <div className="bg-white p-6 rounded-lg shadow-md lg:flex-grow overflow-y-scroll scrollbar-none">
                    <h2 className="text-xl font-semibold mb-4">All Item</h2>
                    <input
                    type="text"
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    className="border px-2 py-1 rounded mb-3"
                />
                      {  isloading ? ( <Loader/>):(
                    <MaterialReactTable
                        columns={columns}
                        data={itemsData}
                        manualPagination
                        muiTablePaginationProps={{
                            rowsPerPageOptions: [10, 20, 50, 100],
                        }}
                        state={{
                            pagination,
                        }}
                        rowCount={rowCount}
                        onPaginationChange={setPagination}
                    />
                      )}
                </div>
                <ItemForm
                    inputs={inputs}
                    setInputs={setInputs}
                    append={append}
                    setAppend={setAppend}
                    editId={editId}
                    factoryLocation={factoryLocation}
                    categoryArray={categoryArray}
                    brandArray={brandArray}
                    addItem={addItem}
                    editItem={editItem}
                    resetHandler={resetHandler}
                />
            </div>
            <div className="flex flex-row gap-6 p-6">
                {/* Extra Charges Table */}
                <div className="bg-white p-6 rounded-lg shadow-md w-[50%]">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold">Extra Charges</h2>
                        <button onClick={charger_Open_Modal} className="bg-purple-500 text-white px-4 py-2 rounded-lg">
                            Add Extra Charge
                        </button>
                    </div>
                    <MaterialReactTable
                        columns={extraChargesColumns}
                        data={extraCharges}
                        enablePagination
                        muiTablePaginationProps={{
                            rowsPerPageOptions: [10, 20, 50],
                        }}
                    />
                </div>

                {/* Purchase Ledger Table */}
                <div className="bg-white p-6 rounded-lg shadow-md w-[50%]">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold">Purchase Ledger</h2>
                        <button onClick={ledger_Open_Modal}className="bg-purple-500 text-white px-4 py-2 rounded-lg">Add Ledger</button>
                       
            {/* This is Open Modal for Add Ledger */}
                {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                    <h2 className="text-xl font-semibold mb-4">Add New Ledger</h2>

                    <input
                        type="text"
                        value={ledgerInput.ledgerName}
                        onChange={(e) =>
                        setLegderInput({ ...ledgerInput, ledgerName: e.target.value })
                        }
                        placeholder="Ledger Name"
                        className="w-full border border-gray-300 rounded-lg p-2 mb-4"
                    />

                    <select
                        onChange={(e) =>
                        setLegderInput({ ...ledgerInput, factory: e.target.value })
                        }
                        value={ledgerInput.factory}
                        className="w-full border border-gray-300 rounded-lg p-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="" disabled>Select Factory</option>
                        {factoryLocation.map((factory) => (
                        <option key={factory._id} value={factory._id}>
                            {factory.fectory_loca_name}
                        </option>
                        ))}
                    </select>

                    <div className="flex justify-end space-x-3 mt-4">
                        <button
                        onClick={closeModal}
                        className="bg-gray-300 px-4 py-2 rounded-lg"
                        >
                        Cancel
                        </button>
                        <button
                        onClick={add_ledger}  
                        className="bg-purple-500 text-white px-4 py-2 rounded-lg"
                        >
                        Submit
                        </button>
                    </div>
                    </div>
                </div>
                )}





                  {/* This is Open Modal for Add Charge */}
                  {isChargeModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                    <h2 className="text-xl font-semibold mb-4">Add New Charge</h2>

                    <input
                        type="text"
                        value={chargeInput.chargeName}
                        onChange={(e) =>
                            setChargeInput({ ...chargeInput, chargeName: e.target.value })
                        }
                        placeholder="Charge Name"
                        className="w-full border border-gray-300 rounded-lg p-2 mb-4"
                    />

                    <select
                        onChange={(e) =>
                            setChargeInput({ ...chargeInput, chargeFactory: e.target.value })
                        }
                        value={chargeInput.chargeFactory}
                        className="w-full border border-gray-300 rounded-lg p-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="" disabled>Select Factory</option>
                        {factoryLocation.map((factory) => (
                        <option key={factory._id} value={factory._id}>
                            {factory.fectory_loca_name}
                        </option>
                        ))}
                    </select>

                    <div className="flex justify-end space-x-3 mt-4">
                        <button
                        onClick={closeModal}
                        className="bg-gray-300 px-4 py-2 rounded-lg"
                        >
                        Cancel
                        </button>
                        <button
                        onClick={addCharge}  
                        className="bg-purple-500 text-white px-4 py-2 rounded-lg"
                        >
                        Submit
                        </button>
                    </div>
                    </div>
                </div>
                )}


                    </div>
                    <MaterialReactTable
                        columns={ledgersColumns}
                        data={ledgers}
                        manualPagination
                        muiTablePaginationProps={{
                            rowsPerPageOptions: [10, 20, 50, 100],
                        }}
                        state={{ pagination: ledgerPagination }}
                        rowCount={ledgerRowCount}
                        onPaginationChange={setLedgerPagination}
                    />
                </div>
            </div>
        </div>
 
    );
};

export default AddItems;